export function height() {
  var height=window.innerHeight;
  document.documentElement.style.setProperty( '--vh', height/100 + 'px');
}